import { openBlock as l, createElementBlock as r, createElementVNode as a, renderSlot as i, createTextVNode as o, toDisplayString as d, createCommentVNode as n } from "vue";
/* empty css                    */
import u from "./design-system.es128.js";
const c = {
  name: "DsModalHeaderTitle",
  props: {
    /**
     * Title to display
     */
    title: String,
    /**
     * Subtitle to display
     */
    subtitle: String
  }
}, m = { class: "ds-modal-header-title" }, p = {
  key: 0,
  class: "ds-modal-header-subtitle"
};
function _(e, s, t, b, f, h) {
  return l(), r("div", null, [
    a("h4", m, [
      i(e.$slots, "title", {}, () => [
        o(d(t.title), 1)
      ], !0)
    ]),
    s[0] || (s[0] = o()),
    t.subtitle || e.$slots.subtitle ? (l(), r("p", p, [
      i(e.$slots, "subtitle", {}, () => [
        o(d(t.subtitle), 1)
      ], !0)
    ])) : n("", !0)
  ]);
}
const k = /* @__PURE__ */ u(c, [["render", _], ["__scopeId", "data-v-06dbe92a"]]);
export {
  k as default
};
//# sourceMappingURL=design-system.es18.js.map
